// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgu_a","AdSlotBranding__desktop":"bgu_b","AdSlotBranding__mobile":"bgu_c"};